import {IApplicationState} from '../../../../../../../types/types';
import { ETemplateType, TTemplateId } from '../types';
import { getTemplatesList } from './getTemplatesList';
import { getSearchQuery } from '../../header/selectors/getSearchQuery';
import { filterTemplatesForSearch } from '../../../helpers/filterTemplatesForSearch';

export const getTemplatesIdsByType = (
    state: IApplicationState,
    templateType: ETemplateType
): TTemplateId[] => {
    const templates = getTemplatesList(state);
    const searchQuery = getSearchQuery(state);
    const templatesFiltered = searchQuery ?
        filterTemplatesForSearch(templates, searchQuery) :
        templates;

    const templatesIds = templatesFiltered.reduce((
        ids,
        template
    ) => {
        if (template.templateInfo.types.includes(templateType)) {
            ids.push(template.id);
        }
        return ids;
    }, []);

    return templatesIds;
};
